<template>
    <div
        :id="`config-section-${number}`"
        class="bsdc:px-5 bsdc:sm:px-[46px] bsdc:lg:px-12"
    >
        <div class="bsdc:mx-auto max-w-large">
            <slot />
        </div>
    </div>
</template>

<script setup>
    defineProps({
        number: Number,
    });
</script>
